import {
  jb_linkedin_icon_css_default
} from "./chunk.GJ7A5QV3.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-linkedin-icon/jb-linkedin-icon.ts
var JbLinkedinIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewbox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.813 2.395c0-.866-.692-1.565-1.546-1.565C1.413.83.72 1.529.72 2.395c0 .863.693 1.562 1.547 1.562s1.546-.7 1.546-1.562zM.973 13.542h2.615V5.067H.972zm6.795-8.475H5.26v8.475h2.51V9.094c0-1.192.546-1.902 1.593-1.902.963 0 1.425.682 1.425 1.902v4.448h2.602V8.176c0-2.272-1.282-3.368-3.074-3.368-1.793 0-2.547 1.399-2.547 1.399z"
        ></path>
      </svg>
    `;
  }
};
JbLinkedinIcon.styles = [reset_css_default, jb_linkedin_icon_css_default];
JbLinkedinIcon = __decorateClass([
  customElement("jb-linkedin-icon")
], JbLinkedinIcon);

export {
  JbLinkedinIcon
};
